import Vue from "vue";

import DComboCount from "./DComboCount";
import DDate from "./DDate";
import DDateList from "./DDateList";

Vue.component("d-date-list", DDateList);
Vue.component("d-date", DDate);
Vue.component("d-combo-count", DComboCount);
